var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.41,
    height: 21.05,
    viewBox: "0 0 20.41 21.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "world-location"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8,3.4a.7.7,0,0,1,0,1.4,8.3,8.3,0,1,0,8.3,8.3.7.7,0,1,1,1.4,0,9.7,9.7,0,1,1-9.7-9.7Z",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,3.7a.66.66,0,0,1,.1.6,27.65,27.65,0,0,0,0,16.6.61.61,0,0,1-.1.6.6.6,0,0,1-.6.3H8.2a.7.7,0,0,1,0-1.4,29.5,29.5,0,0,1,0-15.6C7.8,4.8,9.5,3.5,9.6,3.7Zm6.2,8.2a.68.68,0,0,1,.7.7,28.3,28.3,0,0,1-1.4,8.7.61.61,0,0,1-.9.4c-.4-.1-.5-.5-.4-.9a29.35,29.35,0,0,0,1.3-8.3A.67.67,0,0,1,15.8,11.9Z",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,8.4a.68.68,0,0,1,.7.7c0,.4-.3.6-.7.6A27.15,27.15,0,0,0,4,11a.88.88,0,0,1-.7-.1.55.55,0,0,1-.3-.5V9.5a.7.7,0,0,1,1.4,0A28.45,28.45,0,0,1,12.6,8.4Zm8.2,8.2a30.85,30.85,0,0,1-17.3-.2.72.72,0,0,1-.5-.9,1,1,0,0,1,1-.4,29.64,29.64,0,0,0,17.2,0A8.33,8.33,0,0,1,20.8,16.6Z",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2,12.4c-1.6-1.5-3.3-3.8-2.6-6.7A4.81,4.81,0,0,1,17.3,2h0a4.74,4.74,0,0,1,4.8,3.7c.7,2.8-1,5.2-2.6,6.7a2.94,2.94,0,0,1-2.2.9A4.35,4.35,0,0,1,15.2,12.4ZM13.4,5.9c-.6,2.5,1,4.6,2.4,5.9a2.23,2.23,0,0,0,3.2,0c1.4-1.4,2.9-3.5,2.4-5.9a4,4,0,0,0-4-3.1A3.88,3.88,0,0,0,13.4,5.9Z",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,6.7a2.7,2.7,0,1,1,2.7,2.7A2.75,2.75,0,0,1,14.7,6.7Zm.4,0a2.3,2.3,0,0,0,4.6,0,2.3,2.3,0,0,0-4.6,0Z",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,15.9",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.1 -1.75)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldLocation);
export default __webpack_public_path__ + "static/media/world-location.b7a601057de3b99c7b2eeb65ea9dd953.svg";
export { ForwardRef as ReactComponent };